import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentBankTransferPage } from 'src/app/modals/checkout-payment-bank-transfer/checkout-payment-bank-transfer.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutPaymentBankTransferPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CheckoutPaymentBankTransferPage]
})
export class CheckoutPaymentBankTransferPageModule {}
